import type { ReactNode } from 'react'
import { Box } from '@mui/material'

type ClimateContextBarProps = {
  hazardControl: ReactNode
  emissionControl: ReactNode
  horizonControl?: ReactNode
  adaptationControl?: ReactNode
}

const ClimateContextBar = ({
  hazardControl,
  emissionControl,
  horizonControl,
  adaptationControl,
}: ClimateContextBarProps) => {
  const secondaryControls = [
    { key: 'emission', node: emissionControl },
    { key: 'horizon', node: horizonControl },
    { key: 'adaptation', node: adaptationControl },
  ].filter(control => Boolean(control.node))

  return (
    <Box
      sx={{
        display: 'grid',
        gap: 1.5,
        gridTemplateColumns: {
          xs: '1fr',
          md: 'minmax(220px, 0.8fr) minmax(0, 2.2fr)',
        },
        alignItems: 'stretch',
      }}>
      <Box sx={{ minWidth: 0 }}>{hazardControl}</Box>
      <Box
        sx={{
          display: 'grid',
          gap: 1.5,
          gridTemplateColumns: {
            xs: '1fr',
            sm: `repeat(${secondaryControls.length || 1}, minmax(0, 1fr))`,
          },
          alignItems: 'stretch',
        }}>
        {secondaryControls.map(control => (
          <Box key={control.key} sx={{ minWidth: 0 }}>
            {control.node}
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default ClimateContextBar
